import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import {
    Box,
    Modal,
} from '@mui/material';

import { setSelectedClientdata, setLogout, setShowOrganizationModal, setNoLicenseAccess, setLicences } from '../../redux/actions/actions';
import { Postrequestcall } from '../../request/Postrequest';
import { CLIENT_USE_LICENSES } from '../../constant/Apipath';
import { SelectOrganizationContent } from './SelectOrganizationContent';
import {
    fetchClientEmployeeAppsLicensesDetails,
    normalizeClientEmployeeAppsLicensesResponse
} from '../../client/utils/clientEmployeeAppsLicenses';

// Reusable Modal Component
export const SelectOrganizationDialog = ({ open, onClose, clients, pendingInvitations, onSelectClient, onViewInvite, onLogout, showLogout }) => {
    return (
        <Modal open={open} onClose={onClose} aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description">
            <Box
                className="user-modal-responsive"
                sx={{
                    outline: 'none',
                    maxHeight: '90vh !important', // Use viewport height to ensure fit
                    overflowY: 'auto !important', // Ensure scrolling works
                }}
            >

                <SelectOrganizationContent
                    clients={clients}
                    pendingInvitations={pendingInvitations}
                    onSelectClient={onSelectClient}
                    onViewInvite={onViewInvite}
                    onClose={onClose}
                    onLogout={onLogout}
                    showLogout={showLogout}
                />
            </Box>
        </Modal>
    );
};

const SelectOrganizationModal = () => {
    const { loginData, showOrganizationModal, selectedClientData } = useSelector((state) => state.main);
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const clients = (loginData?.userInformation?.ClientsList || []).filter(
        (client) => client.OrganizationName !== 'BuildID Free'
    );

    const handleSelectClient = async (client) => {
        console.log('client==========', client)
        dispatch(setNoLicenseAccess(false));
        try {
            const payload = {
                ClientId: client.ClientId,
                UserId: client.UserId,
                ClientEmployeeId: client.ClientEmployeeId || client.Id,
                LicenseTypeId: client.Licenses?.[0]?.LicenseTypeId
            };

            const response = await Postrequestcall(CLIENT_USE_LICENSES, payload, loginData?.accessToken);
            const responseMessage =
                response?.data?.message ||
                response?.data?.Message ||
                response?.data?.data?.message ||
                response?.data?.data?.Message ||
                response?.message ||
                "";

            const isNoLicenseError =
                response?.status === 400 &&
                String(responseMessage).toLowerCase().includes("not enough available licenses");

            dispatch(setNoLicenseAccess(isNoLicenseError));

            if (response?.data?.status === false) {
                console.error("License usage failed:", response?.data?.message);
            }

            const clientAppsLicensesResponse = await fetchClientEmployeeAppsLicensesDetails(
                client?.ClientId,
                client?.ClientEmployeeId || client?.Id,
                loginData?.accessToken
            );
            dispatch(
                setLicences(
                    normalizeClientEmployeeAppsLicensesResponse(clientAppsLicensesResponse?.response ?? clientAppsLicensesResponse)
                )
            );

        } catch (error) {
            console.error("Error calling CLIENT_USE_LICENSES", error);
        }
        if (selectedClientData?.ClientId !== client?.ClientId) {
            dispatch(setSelectedClientdata(client));
        }
        if (showOrganizationModal) {
            dispatch(setShowOrganizationModal(false));
        }


        if (client.ClientId && client.ClientId !== 0) {
            navigate(`/client/${client.ClientId}/home`);
        } else {
            navigate('/home');
        }
    };

    const handleLogout = () => {
        dispatch(setLogout(null));
        sessionStorage.clear();
        navigate('/');
    };

    const handleClose = () => {
        dispatch(setShowOrganizationModal(false));
    };

    if (!showOrganizationModal) return null;

    // Check if we are in a mandatory selection state (no client selected yet)
    // If selectedClientData is empty or missing, user MUST select or logout.
    const isMandatory = !selectedClientData || Object.keys(selectedClientData).length === 0 || (!selectedClientData.OrganizationName && !selectedClientData.id);

    return (
        <SelectOrganizationDialog
            open={showOrganizationModal}
            onClose={isMandatory ? undefined : handleClose}
            clients={clients}
            onSelectClient={handleSelectClient}
            onLogout={handleLogout}
            showLogout={isMandatory}
        />
    );
};

export default SelectOrganizationModal;
